module.exports = __webpack_public_path__ + "img/Postmodernisme_Bjorg-Vik.9e556b7e.jpg";